import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiDms} from "./UiDms";
import {UiDmsDocumentEditor} from "./UiDmsDocumentEditor";
import {UiDmsAttaches} from "./UiDmsAttaches";
import {DmsDocumentType} from "./Types";

export class UiNewDocumentAttach extends MuWidget<UiDms, {}, {
	documentEditor: UiDmsDocumentEditor,
	attaches: UiDmsAttaches,
}> {
	// @ts-ignore
	private savedPromise: Promise<any[]>;

	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`
			<div mu-id="documentEditor" mu-widget="UiDmsDocumentEditor"></div>
			<div mu-id="attaches" mu-widget="UiDmsAttaches" mu-params='{"inCreateForm":true}'></div>
			<!-- div class="buttons">
				<span class="btn btn-primary">Vytvořit dokument</span>
			</div -->
		`)
	}

	afterIndex() {
		this.savedPromise = Promise.all([
			this.muNamedWidget.documentEditor.savedPromise,
			this.muNamedWidget.attaches.newSavedPromise()
		]);
		this.muNamedWidget.documentEditor.savedPromise.then(
			(entity) => {
				this.muNamedWidget.attaches.dmsDocumentId = entity.id; //todo id vytvořeného dokumentu
				this.muNamedWidget.attaches.doSaveAttaches();
			}
		);
	}

	async muBindData(srcData: any) {
		await this.muNamedWidget.documentEditor.muBindData(srcData);
	}

	async loadItem(id: number) {
		return this.muNamedWidget.documentEditor.loadItem(id);
	}

	documentEditor_dmsDocumentTypeChange(ev: any, dmsDocumentType: DmsDocumentType) {
		this.muNamedWidget.attaches.showForDmsDocument({
			dmsDocumentTypeId: dmsDocumentType,
			id: 0
		});
		this.container.appendChild(this.muNamedWidget.documentEditor.ui.pButtons);
	}

	// public get savedPromise() {
	// 	return this.muNamedWidget.documentEditor.savedPromise
	// }
}